import { render } from "./MatchContent.vue?vue&type=template&id=dc94a0f2&scoped=true"
import script from "./MatchContent.vue?vue&type=script&lang=js"
export * from "./MatchContent.vue?vue&type=script&lang=js"

import "./MatchContent.vue?vue&type=style&index=0&id=dc94a0f2&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/production-allsports-2/production-as-fe-fj-SSR/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc94a0f2"]])

export default __exports__